import { h, } from "@stencil/core";
import { isBreakpointEqualOrSmaller } from "../../../utils";
import { FocusTrapHelper } from "../../../utils/functions/focusTrapHelper";
import { setScrollLock } from "../../../utils/functions/scrollLock";
export class DcUiHeaderLanguage {
    constructor() {
        this.isMobile = false;
        this.isOpen = false;
        this.updateIsMobile = () => {
            this.isMobile = isBreakpointEqualOrSmaller('xl');
        };
        this.iconClickHandler = () => {
            this.dcFlyoutClose.emit(this.el);
            this.close();
        };
    }
    onOutsideClick(e) {
        if (!this.isOpen)
            return;
        // Get the full path of elements including through shadow DOM boundaries
        const path = e.composedPath();
        // Check if our element is in the path
        if (!path.includes(this.el) && this.isOpen) {
            this.close();
        }
    }
    onKeyDown(e) {
        if (!this.isOpen)
            return;
        if (e.key === 'Escape') {
            this.close();
        }
    }
    // method to open the modal
    async open() {
        setScrollLock(true);
        this.dialog.show();
        setTimeout(() => {
            this.isOpen = true;
        }, 100);
        this.focusTrapHelper.activateFocusTrap();
    }
    // method to close the modal
    async close() {
        if (!this.isMobile) {
            setScrollLock(false);
        }
        this.dialog.close();
        setTimeout(() => {
            this.isOpen = false;
        }, 100);
        this.focusTrapHelper.deactivateFocusTrap();
    }
    async toggle() {
        if (this.dialog.open) {
            this.close();
        }
        else {
            this.open();
        }
    }
    componentDidLoad() {
        this.updateIsMobile();
        window.addEventListener('resize', this.updateIsMobile);
        this.focusTrapHelper = new FocusTrapHelper(this.el);
    }
    disconnectedCallback() {
        window.removeEventListener('resize', this.updateIsMobile);
    }
    render() {
        const backButton = (h("button", { key: '13a9823b591bebcb4b9818fbbf264b5fcd7e9ac8', class: "back-button", onClick: this.iconClickHandler }, h("dc-ui-icon", { key: '88f37ca28deebb4f0290cdd3a389f3256a9751b3', size: "tiny", name: "dc_backward_left" }), this.backButtonLabel));
        const closeButton = (h("dc-ui-button", { key: '4368153c1eeb1d3f91c26067ae30e1948c0d902b', class: "close-button", variant: "link", icon: "dc_close", hideLabel: true, id: "close-icon", size: "small", onClick: this.iconClickHandler }, "Close Modal"));
        return (h("dialog", { key: '2ebff2f06c824de0d4b167a2b4e29434d420f957', class: "language-dialog", ref: (el) => (this.dialog = el) }, h("div", { key: 'e6ee19d1684c7f1753cb0dbbc065a6ca0a14f7b1', class: "dialog-body" }, h("div", { key: 'd0b74c803ed5e5b18cf70718db4a4f2bef134de2', class: "dialog-content" }, h("div", { key: 'c46ad4d4b1e1e884a0cf8bd8172435b5c539f558', class: "title-wrapper" }, this.headline && (h("dc-ui-text", { key: '001794ab7171f55583e5d7ee04c48ea93557ca1d', variant: "h3", color: "darkBlue02" }, this.headline))), h("div", { key: '551fce4cd0330316008de8b18773bf7df6faf465', class: "content-wrapper" }, h("slot", { key: '3e1da2ad8fa551c8686994a507916b093de66fd1' })), this.isMobile ? (this.backButtonLabel ? backButton : closeButton) : closeButton))));
    }
    static get is() { return "dc-ui-header-language"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["dc-ui-header-language.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dc-ui-header-language.css"]
        };
    }
    static get properties() {
        return {
            "headline": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "headline",
                "reflect": false
            },
            "backButtonLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "back-button-label",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "isMobile": {}
        };
    }
    static get events() {
        return [{
                "method": "dcFlyoutClose",
                "name": "dcFlyoutClose",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "HTMLDcUiHeaderLanguageElement",
                    "resolved": "HTMLDcUiHeaderLanguageElement",
                    "references": {
                        "HTMLDcUiHeaderLanguageElement": {
                            "location": "global",
                            "id": "global::HTMLDcUiHeaderLanguageElement"
                        }
                    }
                }
            }];
    }
    static get methods() {
        return {
            "open": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            },
            "close": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            },
            "toggle": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "click",
                "method": "onOutsideClick",
                "target": "window",
                "capture": false,
                "passive": false
            }, {
                "name": "keydown",
                "method": "onKeyDown",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=dc-ui-header-language.js.map
